<template>
    <div>
        <v-container fluid pa-0>
            <v-container fluid grid-list-xl class="toolbar-container">
                  <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                      <v-toolbar color="grey lighten-3" elevation="1">
                          <bc-btn-back></bc-btn-back>
                          <v-toolbar-title class="ml-0">{{$t($route.meta.title)}}</v-toolbar-title>
                          <v-spacer></v-spacer>
                          <bc-modal-print
                              ref="print"
                              @close-method="file_name = null, $refs.print.close()"
                              :file-name="file_name"
                              :no-button="true"
                          ></bc-modal-print>
                          <bc-btn-refresh v-if="log.log_id && log.log_id > 0"
                                @invoke-method="dbGetLog(true)"
                            ></bc-btn-refresh>
                          <v-menu left content-class="no-stripe" v-if="log.log_id && log.log_id > 0">
                              <template slot="activator">
                                  <v-btn icon>
                                      <v-icon>more_vert</v-icon>
                                  </v-btn>
                              </template>
                              <v-list>
                                  <v-list-tile @click="printPDF()">
                                      <v-list-tile-title>
                                          Print
                                      </v-list-tile-title>
                                  </v-list-tile>
                                  <template v-if="hasPerm('logs.update')">
                                      <v-divider class="ml-3 my-0"></v-divider>

                                      <div v-for="item in log_status_options" :key="item.option_id">
                                      <v-list-tile @click="changeStatus(item)" v-if="item.option_id != log.status_id">
                                          <v-list-tile-title>
                                              {{ $t(`lang.mark_as_${item.slug}`) ? $t(`lang.mark_as_${item.slug}`) : `Mark as ${item.option}` }}
                                          </v-list-tile-title>
                                      </v-list-tile>
                                      </div>

                                  </template>
                                  <template v-if="hasPerm('logs.delete')">
                                      <v-divider class="ml-3 my-0"></v-divider>
                                      <v-list-tile @click="$refs.delete_log.openDialog()">
                                          <v-list-tile-title>
                                              Delete
                                          </v-list-tile-title>
                                      </v-list-tile>
                                  </template>
                              </v-list>
                          </v-menu>
                          <bc-tooltip>
                              <template slot="activator">
                                  <v-btn
                                      icon
                                      @mouseup.left="$router.push({ name: 'logs' })"
                                  >
                                      <v-icon>close</v-icon>
                                  </v-btn>
                              </template>
                              {{ $t('lang.back_to_list') }}
                          </bc-tooltip>
                      </v-toolbar>
                  </v-layout>
              </v-container>

            <v-card-text>
                <v-card elevation="10">
                    <v-card-text>
                        <div v-if="log.status" class="ribbon ribbon-top-right" :class="`ribbon-${log.status_class}`"><span class="ribbon-span">{{ log.status }}</span></div>
                        <v-form ref="formLog">
							<v-flex xs12>
								<v-text-field
									v-focus="log_dialog"
									v-model="log.log_id"
									:label="`${$t('lang.log_id')} *`"
									:counter="showCounter(log.log_id, 'logs.log_id')"
									:rules="ifValid('logs.log_id')"
								></v-text-field>
							</v-flex>
							<v-flex xs12>
								<bc-autocomplete
									v-model="log.template_id"
									:label="`${$t('lang.template_id')} *`"
									:items="user_functions_template"
									item-value="template_id"
									item-text="template_id"
									:rules="ifValid('logs.template_id')"
								></bc-autocomplete>
							</v-flex>
							<v-flex xs12>
								<v-text-field
									v-model="log.slug"
									:label="`${$t('lang.slug')} *`"
									:counter="showCounter(log.slug, 'logs.slug')"
									:rules="ifValid('logs.slug')"
								></v-text-field>
							</v-flex>
							<v-flex xs12>
								<v-text-field
									v-model="log.frequency"
									:label="$t('lang.frequency')"
									:counter="showCounter(log.frequency, 'logs.frequency')"
									:rules="ifValid('logs.frequency')"
								></v-text-field>
							</v-flex>
							<v-flex xs12>
								<v-text-field
									v-model="log.minutes"
									:label="$t('lang.minutes')"
									:counter="showCounter(log.minutes, 'logs.minutes')"
									:rules="ifValid('logs.minutes')"
								></v-text-field>
							</v-flex>
							<v-flex xs12>
								<v-text-field
									v-model="log.capture"
									:label="$t('lang.capture')"
									:counter="showCounter(log.capture, 'logs.capture')"
									:rules="ifValid('logs.capture')"
								></v-text-field>
							</v-flex>
							<v-flex xs12>
								<bc-autocomplete
									v-model="log.machine_id"
									:label="$t('lang.machine_id')"
									:items="machines"
									item-value="machine_id"
									item-text="machine_id"
									:rules="ifValid('logs.machine_id')"
								></bc-autocomplete>
							</v-flex>
							<v-flex xs12>
								<bc-autocomplete
									v-model="log.part_id"
									:label="$t('lang.part_id')"
									:items="parts"
									item-value="part_id"
									item-text="part_id"
									:rules="ifValid('logs.part_id')"
								></bc-autocomplete>
							</v-flex>
							<v-flex xs12>
								<v-text-field
									v-model="log.supervisor_id"
									:label="$t('lang.supervisor_id')"
									:counter="showCounter(log.supervisor_id, 'logs.supervisor_id')"
									:rules="ifValid('logs.supervisor_id')"
								></v-text-field>
							</v-flex>
							<v-flex xs12>
								<v-textarea
									v-model="log.notes"
									:label="$t('lang.notes')"
									auto-grow
									rows="1"
									:rules="ifValid('logs.notes')"
								></v-textarea>
							</v-flex>
							<v-flex xs12>
								<bc-autocomplete
									v-model="log.file_id"
									:label="$t('lang.file_id')"
									:items="files"
									item-value="file_id"
									item-text="file_id"
									:rules="ifValid('logs.file_id')"
								></bc-autocomplete>
							</v-flex>
							<v-flex xs12>
								<v-text-field
									v-model="log.version"
									:label="`${$t('lang.version')} *`"
									:counter="showCounter(log.version, 'logs.version')"
									:rules="ifValid('logs.version')"
								></v-text-field>
							</v-flex>
							<v-flex xs12>
								<bc-select
									v-model="log.active"
									:label="`${$t('lang.active')} *`"
									:items="[]"
									item-value="value"
									item-text="text"
									:rules="ifValid('logs.active')"
								></bc-select>
							</v-flex>


                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn @mouseup.left="$router.push({ name: 'logs' })" flat >{{$t('lang.cancel')}}</v-btn>
                        <v-btn color="success" @click="saveLogs">{{$t('lang.save')}}</v-btn>
                    </v-card-actions>
                </v-card>
            </v-card-text>

            <delete-confirmation-dialog
                ref="delete_log"
                headline="Confirm Delete?"
                :heading="$t('lang.delete_log')"
                :message="$t('lang.delete_log_confirm')"
                @onConfirm="deleteLogs()"
            ></delete-confirmation-dialog>
            <delete-confirmation-dialog
                ref="delete_log_details"
                :heading="$t('lang.delete_package')"
                @onConfirm="confirmDeleteLogDetails()"
            ></delete-confirmation-dialog>
        </v-container>
    </div>
</template>
<script>
import { mapState, mapActions, mapMutations } from "vuex";
import { store } from "Store/store";

export default {
    data() {
        return {
            mobile_list: [{ title: this.$t("lang.print"), action: "printPDF" }],

            formData: {},
            log: { },
            file_name: "",
            dbGetLog: _.debounce(this.getLog, 1500, { maxWait: 1500, leading: true, trailing: false }),
            customers: null,
        };
    },
    beforeRouteUpdate(to, from, next) {
        const id = `${to.params.id}`;

        if (id !== "undefined") {
            this.$store
                .dispatch("fetchLog", {
                    id: id,
                })
                .then((data) => {
                    if (typeof data !== "undefined" && data.log) {
                        this.log = this.assignObj2(data.log, this.rules_logs);

                        this.$store.dispatch("fetchSetting", {
                            url: "options?slug=log_status&sort_by=2",
                            method: "get",
                            stateProperty: "log_status_options",
                            dataProperty: "options",
                            commit: true,
                        });

                        this.finishLoader();
                        next();
                    } else {
                        next({ name: "logs", replace: true });
                    }
                });
        } else {
            this.finishLoader();
            next();
        }
    },
    beforeRouteEnter(to, from, next) {
        const id = `${to.params.id}`;

        if (id !== "undefined") {
            store
                .dispatch("fetchLog", {
                    id: id,
                })
                .then((data) => {
                    if (typeof data !== "undefined" && data.log) {
                        next((vm) => {
                            vm.log = vm.assignObj2(data.log, vm.rules_logs);

                            store.dispatch("fetchSetting", {
                                url: "options?slug=log_status&sort_by=2",
                                method: "get",
                                stateProperty: "log_status_options",
                                dataProperty: "options",
                                commit: true,
                            });

                            vm.finishLoader();
                        });
                    } else {
                        next({ name: "logs", replace: true });
                    }
                });
        } else {
            next((vm) => {
                vm.finishLoader();
            });
        }

        /*store.dispatch("fetchSetting", {
            url: "options?slug=log_status&sort_by=2",
            method: "get",
            stateProperty: "log_status_options",
            dataProperty: "options",
            commit: true,
        });*/
    },
    computed: {
        ...mapState({
            rules_logs: (state) => state.logs.rules_logs,
            log_status_options: (state) => state.settings.log_status_options,
            logs: (state) => state.logs.logs,
            selectedLog: (state) => state.logs.selectedLog,
			user_functions_template: (state) => state.user_functions_template.user_functions_template,
			machines: (state) => state.machines.machines,
			parts: (state) => state.parts.parts,
			files: (state) => state.files.files,

        }),
    },
    methods: {
        ...mapActions([
            "fetchLog",
            "saveLog",
            "deleteLog",
            "printLog",
			"fetchUserFunctionsTemplate",
			"fetchMachines",
			"fetchParts",
			"fetchFiles",

        ]),
        ...mapMutations(["validationOn", "validationOff", "toggleGlobalSnackbar", "toggleModalLoader"]),

        getLog(pg_refresh = false) {
            this.startLoader();

            this.fetchLog({
                id: `${this.$route.params.id}`,
            }).then((data) => {
                if (typeof data !== "undefined" && data.log) {
                    this.log = this.assignObj2(data.log, this.rules_logs);
                    this.toggleModalLoader(false);
                    this.validationOff();
                    this.finishLoader(pg_refresh);
                }
            });
        },
        printPDF() {
            this.dev_mode ? this.$refs.print.openDialog() : this.toggleGlobalSnackbar(true);

            this.printLog({
                id: `${this.$route.params.id}`,
            }).then((data) => {
                if (typeof data != "undefined" && data.log) {
                    if (this.dev_mode) {
                        this.file_name = data.log.file_name;
                    } else {
                        this.$refs.print.printReport(data.log.file_name);
                    }

                    if (!this.dev_mode) this.toggleGlobalSnackbar(false);
                } else {
                    this.file_name = "";
                    this.$refs.print.close();
                    this.createAlert();
                }
            });
        },
        saveLogs() {
            this.validationOn();
            this.$nextTick(() => {
                if (this.validateForm("formLog")) {
                    let body = this.prepForm(this.log, this.rules_logs);

                    this.saveLog({
                        body: body,
                    }).then((data) => {
                        if (typeof data != "undefined" && data.log) {
                            this.$router.push({ name: "log", params: { id: data.log.log_id } });
                        } else {
                        }
                    });
                }
            });
        },
        changeStatus(item) {
            this.status_loader = true;
            let body = { log_id: `${this.$route.params.id}`, status_id: item.option_id };

            this.saveLogs({
                body: body,
            }).then((data) => {
                if (typeof data != "undefined" && data.log) {
                    this.log = this.assignObj2(data.log, this.rules_logs);
                }
            });
        },
        deleteLogs() {
            this.deleteLog({
                id: `${this.$route.params.id}`,
            }).then((data) => {
                console.log(data);
                if (data && data.code == "200") {

                    this.validationOff();
                    this.$router.push({ name: "logs" });
                }
                this.toggleModalLoader(false);
            });
        },
        async refresh(force=false) {
            this.startLoader();

            if (force == true) {
                await this.fetchLog({
                    id: `${this.$route.params.id}`,
                }).then((data) => {
                    if (typeof data !== "undefined" && data.log) {
                        this.log = this.assignObj2(data.log, this.rules_logs);
                        this.toggleModalLoader(false);
                        this.validationOff();
                        this.finishLoader(true);
                    }
                });
            } else {
                this.finishLoader();
            }

			if (this.user_functions_template.length == 0 || force == true) await this.fetchUserFunctionsTemplate({ body: { options: 1 } });
			if (this.machines.length == 0 || force == true) await this.fetchMachines({ body: { options: 1 } });
			if (this.parts.length == 0 || force == true) await this.fetchParts({ body: { options: 1 } });
			if (this.files.length == 0 || force == true) await this.fetchFiles({ body: { options: 1 } });

        },
    },
    mounted() {
        this.refresh();
    },
    created() {
    },
};
</script>
